import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
type DiscordLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const DiscordLogo: React.FC<DiscordLogoProps> = t0 => {
  const $ = _c(13);
  let height;
  let props;
  let t1;
  let t2;
  let width;
  if ($[0] !== t0) {
    ({
      size: t1,
      color: t2,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = width;
  } else {
    height = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    width = $[5];
  }
  const size = t1 === undefined ? 16 : t1;
  const color = t2 === undefined ? "#5865F2" : t2;
  const t3 = width ?? size;
  const t4 = height ?? size * 0.77734375;
  let t5;
  if ($[6] !== color) {
    t5 = <path fill={color} d="M216.856 16.597A208.5 208.5 0 0 0 164.042 0c-2.275 4.113-4.933 9.645-6.766 14.046q-29.538-4.442-58.533 0c-1.832-4.4-4.55-9.933-6.846-14.046a207.8 207.8 0 0 0-52.855 16.638C5.618 67.147-3.443 116.4 1.087 164.956c22.169 16.555 43.653 26.612 64.775 33.193A161 161 0 0 0 79.735 175.3a136.4 136.4 0 0 1-21.846-10.632 109 109 0 0 0 5.356-4.237c42.122 19.702 87.89 19.702 129.51 0a132 132 0 0 0 5.355 4.237 136 136 0 0 1-21.886 10.653c4.006 8.02 8.638 15.67 13.873 22.848 21.142-6.58 42.646-16.637 64.815-33.213 5.316-56.288-9.08-105.09-38.056-148.36ZM85.474 135.095c-12.645 0-23.015-11.805-23.015-26.18s10.149-26.2 23.015-26.2 23.236 11.804 23.015 26.2c.02 14.375-10.148 26.18-23.015 26.18m85.051 0c-12.645 0-23.014-11.805-23.014-26.18s10.148-26.2 23.014-26.2c12.867 0 23.236 11.804 23.015 26.2 0 14.375-10.148 26.18-23.015 26.18" />;
    $[6] = color;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <svg xmlns="http://www.w3.org/2000/svg" width={t3} height={t4} viewBox="0 0 256 199" preserveAspectRatio="xMidYMid" aria-hidden="true" role="img" aria-label="Discord logo" {...props}>{t5}</svg>;
    $[8] = props;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};